import { FlatAspect, ItemAttributeOption } from "@/models/HomePageSearchResponse";

const GENDER_OPTIONS: FlatAspect[] = [
  { id: "201", label: "Colt", slug: "colt" },
  { id: "203", label: "Filly", slug: "filly" },
  { id: "202", label: "Gelding", slug: "gelding" },
  { id: "204", label: "Mare", slug: "mare" },
  { id: "205", label: "Stallion", slug: "stallion" },
];

export default GENDER_OPTIONS;

export const GENDER_ATTRIBUTE_OPTIONS: ItemAttributeOption[] = GENDER_OPTIONS.map((gender) => ({
  label: gender.label,
  value: gender.id,
}));
